import { useEffect, useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { fetchAvatar } from '../features/auth/authApi';

/**
 * The signed-in user's profile picture as an object URL, or '' when they have
 * none. Refetches whenever the picture changes (`avatarUpdatedAt` moves), so a
 * fresh upload on the profile page shows up in the header without a reload.
 * Only meaningful while authenticated — `/users/me/avatar` is self-scoped.
 */
export function useAvatarUrl() {
  const avatarUpdatedAt = useAuthStore((s) => s.user?.avatarUpdatedAt);
  const [url, setUrl] = useState('');

  useEffect(() => {
    if (!avatarUpdatedAt) {
      setUrl('');
      return undefined;
    }
    let objectUrl;
    let cancelled = false;
    fetchAvatar()
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [avatarUpdatedAt]);

  return url;
}
